import { getAssignedAmount } from './_helpers/getAssigendAmount'

const initialState = {
  selectedBookings: [],
  selectedProceeding: null,
  assignedAmount: 0,
}

const ACTION_PREFIX = 'bookingSelection/list'
const SET_SELECTED_BOOKINGS = `${ACTION_PREFIX}/setSelectedBookings`
const SET_SELECTED_PROCEEDING = `${ACTION_PREFIX}/setSelectedProceeding`
const RESET_STATE = `${ACTION_PREFIX}/resetState`

export default function bookingSelectionListReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SELECTED_BOOKINGS: {
      const { bookings } = action
      const assignedAmount = getAssignedAmount(bookings)
      return {
        ...state,
        selectedBookings: bookings,
        assignedAmount,
      }
    }
    case SET_SELECTED_PROCEEDING: {
      const { name } = action
      return { ...state, selectedProceeding: name }
    }
    case RESET_STATE: {
      return initialState
    }
    default: {
      return { ...state }
    }
  }
}

export const setSelectedBookings = (bookings) => ({ type: SET_SELECTED_BOOKINGS, bookings })
export const setSelectedProceeding = (name) => ({ type: SET_SELECTED_PROCEEDING, name })
export const resetState = () => ({ type: RESET_STATE })
